<div class="container-fluid otp-box">
  <div class="row align-items-center linear-background" style="height: 27vh">
    <div class="col-12 text-center">
      <img class="mb-3 img-css" src="assets/icon/logowhite.png" alt="" />
      <p></p>
      <h2 class="PNEB68" style="color: #ffffff26">PICAGGO</h2>
    </div>
  </div>

  <div class="row align-items-center">
    <div class="col-12 p-0">
      <mat-card class="card-css">
        <mat-card-content class="text-center">
          <h2 class="text-center OSSB30 Gray2-color mt-3">OTP Verification</h2>

          <p class="text-center Gray2-color PNR16">
            We have sent you the OTP on {{ phoneNumber }}
          </p>

          <p class="text-center PNR16 mt-5 mb-5">
            Didn’t recieve OTP? &nbsp;
            <button
              mat-stroked-button
              *ngIf="timerOn"
              class="rounded-pill Grey2-boarder-color OSSB14 Grey2-color OSSB14"
            >
              Resend {{ remaining }}s
            </button>
            <button
              mat-stroked-button
              *ngIf="!timerOn"
              (click)="resendOTP()"
              class="rounded-pill OSSB14 linear-button"
            >
              Resend
            </button>
          </p>

          <form [formGroup]="form">
            <div class="row pe-3 ps-3" style="place-content: center">
              <div
                class="form-group col-sm-2"
                *ngFor="let input of formInput; index as i"
              >
                <input
                  #formRow
                  type="tel"
                  formControlName="{{ input }}"
                  class="form-control"
                  maxlength="1"
                  (keyup)="keyUpEvent($event, i)"
                />
              </div>
            </div>
          </form>
          <div id="sign-in-button" class="w-100"></div>

          <button
            mat-raised-button
            (click)="onSubmit()"
            class="rounded-pill mt-5 mb-3 OSSB14 ps-5 pe-5 linear-button"
          >
            Confirm
          </button>
          <br />
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
